<template>
  <v-card class="card-form">
    <v-card-title class="text-h5">
      <img class="card-form__logo" :src="require('@/assets/svg/logo.svg')" alt="" />
    </v-card-title>
    <hr class="card-form__hr-solid" />
    <v-card-text>
      <div class="card-form__name">Sign In</div>
      <v-alert v-if="!!errorText.length" icon="warning" type="error" closable @click:close="errorText = []">
        {{ errorText[0] }}
      </v-alert>
      <div class="card-form__main">
        <v-form ref="form" @submit.prevent="sendForm()">
          <v-text-field
            v-model="credentials.username"
            color="primary"
            variant="outlined"
            label="Your email"
            placeholder="Enter your email"
            :rules="[rules.required, rules.isEmail]"
          />
          <v-text-field
            v-model="credentials.password"
            color="primary"
            variant="outlined"
            label="Password"
            placeholder="Enter your password"
            type="password"
            :rules="[rules.required]"
          />
          <div class="d-flex mb-5">
            <v-checkbox
              v-model="remember"
              label="Remember me"
              color="primary"
              style="display: flex; font-size: small"
            />
            <v-spacer />
            <a
              href="/"
              @click.prevent="$emit('change', 'resetPassword')"
              style="display: flex; margin: auto 0; font-size: 0.9rem"
            >
              Forgot Password?
            </a>
          </div>
          <p class="card-form__tnc-text">
            By continuing, I agree to the
            <a href="https://app.termly.io/policy-viewer/policy.html?policyUUID=874f765d-45a2-464f-9bd0-73f440476bcb"
              >Terms and Conditions</a
            >
            and
            <a href="https://app.termly.io/policy-viewer/policy.html?policyUUID=0bfddd13-3802-4d71-980c-6e7aff261e4a"
              >Privacy Policy</a
            >. I also agree to receive transactional and promotional emails and text messages. I may reply STOP or
            update my profile settings to cancel. Standard messaging and data rates apply.
          </p>
          <v-btn type="submit" class="card-form__send-button" color="primary" large> Sign In </v-btn>
        </v-form>
      </div>
      <div v-if="shouldShowSignUp()" class="card-form__footer">
        Don’t have an account?
        <a href="/" @click.prevent="$emit('change', 'signup')">Sign up here</a>
      </div>
      <div style="min-height: 50px"></div>
    </v-card-text>
  </v-card>
</template>

<script lang="ts">
import { Vue, Component, Emit } from "vue-facing-decorator";
import validationRules from "../../validation/validationRules";
import { authService } from "../../services/authServiceInstance";

@Component({
  emits: ["change", "sent"],
})
export default class LoginForm extends Vue {
  rules = {
    required: (v) => validationRules.checkRequired(v) || "",
    isEmail: (v) => validationRules.checkEmail(v) || "",
  };

  remember = true;
  errorText = [];
  credentials = {
    username: "",
    password: "",
  };

  async isValid() {
    return (this.$refs.form as typeof Vue & { validate: () => boolean }).validate();
  }

  shouldShowSignUp() {
    const currentOrigin = window.location.origin;
    if (currentOrigin === process.env.VUE_APP_ROOMCHOICE_APP_URL) {
      return false;
    }
    return true;
  }

  async sendForm() {
    const isValid: any = await this.isValid();
    if (!isValid.valid) return false;

    try {
      await authService.login(this.credentials);
      // Just to close modal
      this.$emit("sent");
      authService.redirectAfterLogin();
    } catch (error) {
      this.errorText = [];
      const { response } = error as { response: { data: any } };
      const resData = response.data;
      if (resData) {
        for (const key in resData) {
          if (typeof resData[key] === "string") {
            this.errorText.push(resData[key]);
          } else {
            this.errorText.push(resData[key][0]);
          }
        }
      }
    }
  }
}
</script>
